const getOrCreateLegendList = (chart, id) => {
    const legendContainer = document.getElementById(id);
    let listContainer = legendContainer.querySelector("ul");
    if (!listContainer) {
        listContainer = document.createElement("ul");
        listContainer.style.display = "flex";
        listContainer.style.flexDirection = "column";
        listContainer.style.margin = "0";
        listContainer.style.padding = "0";
        listContainer.style.paddingLeft = "10px";
        listContainer.style.fontSize = "12px";
        legendContainer.appendChild(listContainer);
    }
    return listContainer;
};
  
export const htmlLegendPlugin = {
    id: "htmlLegend",
    afterUpdate(chart, args, options) {
        const ul = getOrCreateLegendList(chart, options.containerID);
  
        // Remove old legend items
        while (ul.firstChild) {
            ul.firstChild.remove();
        }
  
        // Reuse the built-in legendItems generator
        const items = chart.options.plugins.legend.labels.generateLabels(chart);
  
        items.forEach(item => {
            const li = document.createElement("li");
            li.style.alignItems = "center";
            li.style.cursor = "pointer";
            li.style.display = "flex";
            li.style.flexDirection = "row";
            li.style.marginBottom = "10px";
    
            li.onclick = () => {
                const { type } = chart.config;
                if (type === "pie" || type === "doughnut") {
                    // Pie and doughnut charts only have a single dataset and visibility is per item
                    chart.toggleDataVisibility(item.index);
                } else {
                    chart.setDatasetVisibility(item.datasetIndex, !chart.isDatasetVisible(item.datasetIndex));
                }
                chart.update();
            };

            li.onmouseover = () => {
                const datasetIndex = item.datasetIndex ?? 0;
                const index = item.index ?? chart.data.datasets[datasetIndex].data.findIndex(i => i as number > 0);
                const activeElement = {
                    datasetIndex,
                    index: index > -1 ? index : 0
                };
                const chartArea = chart.chartArea;
                chart.tooltip.setActiveElements([activeElement],
                    {
                        x: (chartArea.left + chartArea.right) / 2,
                        y: (chartArea.top + chartArea.bottom) / 2,
                    });
                chart.update();
            };
    
            // Color box
            const boxSpan = document.createElement("span");
            boxSpan.style.background = item.fillStyle;
            boxSpan.style.borderColor = item.strokeStyle;
            boxSpan.style.borderWidth = item.lineWidth + "px";
            boxSpan.style.display = "inline-block";
            boxSpan.style.flexShrink = "0";
            boxSpan.style.height = "15px";
            boxSpan.style.width = "15px";
            boxSpan.style.marginRight = "10px";
    
            // Text
            const textContainer = document.createElement("p");
            textContainer.style.color = item.fontColor;
            textContainer.style.margin = "0";
            textContainer.style.padding = "0";
            textContainer.style.textDecoration = item.hidden ? "line-through" : "";
    
            const text = document.createTextNode(item.text);
            textContainer.appendChild(text);
    
            li.appendChild(boxSpan);
            li.appendChild(textContainer);
            ul.appendChild(li);
        });
    }
};